<template>
  <button class="base-button" :class="[{ 'base-button--outline': outline }, sizeBtn ]" v-on=$listeners>
    <div class="base-button__content">
      <slot />
    </div>
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    outline: { type: Boolean, default: false },
     fullWidth: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    sizeBtn() {
      const classSizeBtn = {
        'base-button_lg': this.fullWidth
      }
      return classSizeBtn;
    }
  }
}
</script>

<style>
.base-button {
  min-height: 34px;

  font-size: 13px;
  color: #ffffff;
  background: #2EA3FF;
  border: 1px solid #2EA3FF;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
}

.base-button:disabled {
  background: #777;
  border: 1px solid #777;
  cursor: not-allowed;
}

.base-button__content {
  padding: 0 24px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.base-button--outline {
  background: transparent;
  border-color: inherit;
  color: inherit;
}

.base-button--outline:hover {
  border-color: #2EA3FF;
  color: #2EA3FF;
}

.base-button_lg {
  width: 100%;
}
</style>
